<div class="phone-container">
  <p-select 
    [formControl]="countryControl"
    [options]="countries"
    [filter]="true"
    [filterBy]="'name,dialCode'"
    [showClear]="false"
    filterPlaceholder="{{ 'primeng.search' | translate }}"
    optionLabel="name"
    emptyFilterMessage="{{ 'primeng.emptyFilterMessage' | translate }}"
    emptyMessage="{{ 'primeng.noCountryFound' | translate }}"
  >
    <ng-template pTemplate="selectedItem" let-country>
      <div class="country-item">
        <img 
          [src]="'https://flagcdn.com/' + country.code.toLowerCase() + '.svg'" 
          [alt]="country.name"
          width="20"
        >
        <span class="ml-2">+{{country.dialCode}}</span>
      </div>
    </ng-template>
    
    <ng-template pTemplate="item" let-country>
      <div class="country-item">
        <img 
          [src]="'https://flagcdn.com/' + country.code.toLowerCase() + '.svg'" 
          [alt]="country.name"
          width="20"
        >
        <span class="ml-2">{{country.name}}</span>
        <span class="dial-code">+{{country.dialCode}}</span>
      </div>
    </ng-template>
  </p-select>
 
  <p-iconField iconPosition="left" style="width: 100% !important;">
    <p-inputIcon styleClass="pi pi-phone" />
    <input  pInputText
    type="tel"
    [formControl]="phoneControl"
    placeholder="{{'form.phoneNumber' | translate}}"
    (input)="formatPhoneNumber($event)"
    class="w-full" />
</p-iconField>

 <!--  <span class="p-input-icon-left p-input-icon-right flex-1">
    <i class="pi pi-phone"></i>
    <input 
      pInputText
      type="tel"
      [formControl]="phoneControl"
      placeholder="{{'form.phoneNumber' | translate}}"
      (input)="formatPhoneNumber($event)"
      class="w-full"
    >
    @if (phoneControl.value) {
      <i [class]="isValid ? 'pi pi-check text-green-500' : 'pi pi-times text-red-500'"></i>
    }
  </span> -->
</div>

@if (showError && !isValid && phoneControl.value) {
  <small class="p-error block mt-2">{{'form.invalidPhoneNumber' | translate}}</small>
}